
import './Footer.css';
import { Link } from 'react-router-dom';
import footer from '../assets/footer.png'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Navigation</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/projects">Projects</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Social Media</h4>
            <ul>
              <li><a href="https://www.facebook.com/profile.php?id=61578951203920" target="_blank" rel="noopener noreferrer">Facebook</a></li>
              <li><a href="https://www.instagram.com/10designsfirm" target="_blank" rel="noopener noreferrer">Instagram</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Location</h4>
            <div className="address">
              <p>Villa 151, Saket Bhu Satva </p>
              <p>Kompally, Hyderabad</p>
            </div>
            <button className="location-btn">Location</button>
          </div>
        </div>



      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div className="footer-credit" style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
          <img src={footer} alt="logo" style={{ height: '40px',background:'white',widt:'40px',borderRadius:'50%' }} />
          <a href='https://www.srimahardiiisol.com/' target='_blank' rel="noreferrer" ><p style={{ margin: 0}}>
            Developed by <strong>SRI MAHARDIII SOL PVT LTD</strong>
          </p></a>
        </div>
      </div>


    </footer>
  );
};

export default Footer; 